const types = {
  SET_IS_REPORT_LOADING: 'SET_IS_REPORT_LOADING',
  SET_RANGE_DAYS: 'SET_RANGE_DAYS',
  SET_USE_CASE_TYPE: 'SET_USE_CASE_TYPE',
  SET_OVERVIEW_DASHBOARD_FILTER: 'SET_OVERVIEW_DASHBOARD_FILTER',
};

export default types;
